import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ListingFormValues } from "@/components/listings/filters/FilterSchema";
import { UseFormReturn } from "react-hook-form";
import { useListingWizardContext } from "@/context/ListingWizardContext";

export const useFormSubmit = () => {
  const navigate = useNavigate();
  const { form, saveCurrentStep, publishListing, setIsSubmitting, listingId } =
    useListingWizardContext();

  const handleSubmit = async (data: ListingFormValues) => {
    setIsSubmitting(true);

    try {
      // First, save any remaining data (validation will be handled by publishListing)
      const savedListing = await saveCurrentStep(); // Capture the returned listing

      // Then, if we have a listing ID (either from state or newly created), publish it
      const finalListingId = listingId || savedListing?.id;

      if (finalListingId) {
        await publishListing();
        toast.success("Property listing published successfully!");
        navigate("/dashboard/listings");
      } else {
        toast.error("No listing ID found. Please try again.");
      }
    } catch (error) {
      toast.error("Failed to create property listing. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return { handleSubmit };
};
